import type { Exercise } from '../types/workout';
import { ExerciseEditor } from './ExerciseEditor';

interface ExerciseListProps {
  date: string;
  sessionIndex: number;
  exercises?: Exercise[];
}

export function ExerciseList({ date, sessionIndex, exercises }: ExerciseListProps) {
  const list = exercises ?? [];

  if (list.length === 0) {
    return (
      <div className="py-6 text-center text-gray-400 text-sm">
        No exercises yet. Click "Add Exercise" to get started.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {list.map((exercise, index) => (
        <ExerciseEditor
          key={index}
          date={date}
          sessionIndex={sessionIndex}
          exercise={exercise}
          exerciseIndex={index}
        />
      ))}
    </div>
  );
}
